import AppShell from "components/AppShell";
import PerformanceReview from "components/PerformanceReview";
import PerformanceReview4c from "components/PerformanceReview4c";
import CaseMasterPerformance from "components/CaseMasterPerformance";

export const InteractiveDemo4c = () => {
  return (
    <AppShell headerLabel="Feedback" showSidebar={false} showDemoAppNavbar={false}>
      <PerformanceReview4c />
    </AppShell>
  );
}

export const InteractiveDemoCaseMaster = () => {
  return (
    <AppShell headerLabel="Case Interview report" showSidebar={false} showDemoAppNavbar={false}>
      <CaseMasterPerformance />
    </AppShell>
  );
}

export default function InteractiveDemoPerformance() {

  return (
    <AppShell headerLabel="Feedback" showSidebar={false} showDemoAppNavbar={false}>
      <PerformanceReview />
    </AppShell>
  );
}